export default "__VITE_ASSET__HNmSCInh__"